import { colors } from '@/theme/colors';

interface AlertProps {
  color?: string;
  size?: { width: number; height: number };
}

export default function Alert({
  color = colors.neutral10,
  size = { width: 24, height: 24 },
}: AlertProps) {
  return (
    <svg
      width={size.width}
      height={size.height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <circle
        cx="12"
        cy="16.75"
        r="1.25"
        transform="rotate(-180 12 16.75)"
        fill={color}
      />
      <path
        d="M12 13L12 7"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
